import { Flex } from '@rebass/grid';
import { isEmpty } from 'lodash-es';
import React from 'react';
import { Button, LoaderWrapper } from '../../../components';
import { NewsletterArticle } from '../../NewsletterContainer/NewsletterArticle';
import NewsletterArticleV2 from '../../NewsletterContainer/NewsletterArticle/NewsletterArticleV2';
import { ModalArticlesContainer } from '../ArticleModal.styles';

const AddContentArticlesV2 = ({ 
    articleType, 
    setArticleType, 
    articleData, 
    selectedArticles, 
    themeNames,
    handleArticleClick,
    showLoadMore,
    loadMoreHandler,
    loader
}) => {
    return (
        <Flex width="98%" flexDirection='column' style={{ overflowX: 'auto', overflowY: 'hidden', margin: 'auto' }}>
            <Flex justifyContent='start' alignItems='center'>
                <div
                    style={{
                        color: articleType === 'bookmarked' ? '#ffffff' : '#000000',
                        background: articleType === 'bookmarked' ? '#816EF8' : '#ffffff',
                        cursor: 'pointer',
                        border: articleType === 'bookmarked' ? '1px solid #6351ed' : '1px solid #e4e7ec',
                        padding: '10px 15px',
                        borderRadius: '10px 0 0 10px',
                    }}
                    onClick={() => setArticleType('bookmarked')}
                >
                    Bookmarked
                </div>
                <div
                    style={{
                        color: articleType === 'recommended' ? '#ffffff' : '#000000',
                        background: articleType === 'recommended' ? '#816EF8' : '#ffffff',

                        cursor: 'pointer',
                        border: articleType === 'recommended' ? '1px solid #6351ed' : '1px solid #e4e7ec',
                        padding: '10px 15px',
                    }}
                    onClick={() => setArticleType('recommended')}
                >
                    Recommended
                </div>
                <div
                    style={{
                        color: articleType === 'my-content' ? '#ffffff' : '#000000',
                        background: articleType === 'my-content' ? '#816EF8' : '#ffffff',

                        cursor: 'pointer',
                        border: articleType === 'my-content' ? '1px solid #6351ed' : '1px solid #e4e7ec',
                        padding: '10px 15px',
                        borderRadius: '0 10px 10px 0',
                    }}
                    onClick={() => setArticleType('my-content')}
                >
                    My Content
                </div>
            </Flex>
            <ModalArticlesContainer  justifyContent="space-between" bgColor='#ffffff' border='none'>
                {!isEmpty(articleData[articleType]) ? articleData[articleType].map((item, index) => (
                    <div
                        style={{
                            textAlign: 'center',
                            marginRight: '12px',
                            marginBottom: '10px',
                            borderRadius: '8px',
                            border: selectedArticles.includes(item.id) ? '1px solid #6351ed' : '1px solid #E4E7EC',
                            cursor: 'pointer',
                            width: '23%',
                        }}
                    >
                        <NewsletterArticleV2
                            key={index}
                            articleIndex={index}
                            margin="0px"
                            {...item}
                            themeNames={themeNames}
                            newsletterArticles={selectedArticles}
                            article={item}
                            deleteBlocked
                            width='100%'
                            height='200px'
                            imgWidth='100%'
                            maxImgWidth='100%'
                            articleType={articleType}
                            handleBucketArticleClick={handleArticleClick}
                        />
                    </div>
                )) : (
                    <Flex justifyContent='center' alignItems='center' style={{ width: '100%', height: '300px' }}>No articles found</Flex>
                )}
            </ModalArticlesContainer>
            {articleType === 'my-content' && (
                <LoaderWrapper isLoading={loader}>
                    <Button 
                       margin='20px auto 0px' 
                       width='110px' 
                       borderRadius='4px'
                       bgColor='#ffffff'
                       borderColor='#E4E7EC'
                       color='black'
                       onClick={loadMoreHandler}
                       disabled={!showLoadMore}
                    >
                        Load More
                    </Button>
                </LoaderWrapper>
            )}
        </Flex>
    );
};

export default AddContentArticlesV2;